import React from 'react';
import { observer } from "mobx-react-lite";
import userStorage from "../storages/userStorage";
import { App, Button, Flex, Form, Input } from "antd";

function AuthCheck(props: any) {
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const { notification} = App.useApp();

  const { isAuthorized } = userStorage;

  if (isAuthorized) return <>{props.children}</>;

  return (
    <Form style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'white',
      width: '100vw',
      height: '100vh',
    }}>
      <Flex vertical>
        <Input
          style={{
            width: 300,
            height: 50,
            fontSize: 24,
          }}
          placeholder="login"
          name="login"
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
        <Input
          style={{
            width: 300,
            height: 50,
            fontSize: 24,
          }}
          placeholder="password"
          name="password"
          type="password"
          onChange={(e) => {
            setPassword(e.target.value);
          }}
        />
        <Button
          style={{
            width: 300,
            height: 50,
            fontSize: 24,
          }}
          onClick={async () => {
            try {
              await userStorage.login(email, password);
            } catch (e: any) {
              notification.error({ message: e.message });
            }
          }}
        >
          Login
        </Button>
      </Flex>
    </Form>
  );
}

export default observer(AuthCheck);
